import axios from "axios";
import store from "../../redux/store";
import { setIsLoading } from "../../redux/loader/action";
import { setCurrentUser } from "../../redux/game/action";

export const on_sign_in = async (id, history, joincode = null) => {
  let url = `${process.env.REACT_APP_GET_COGNITO_ATTRIBUTES}${id}`;
  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    let attributes = res.data;
    let dataObj = {
      userName: attributes.name,
      email: attributes.email,
      userId: attributes.Username,
      picture:
        attributes.picture ||
        attributes["custom:profile_picture"] ||
        "https://cdn.comedywire.com/images/default-profile-icon.png",
      team_code: attributes["custom:promocode"],
      team_code_description: attributes["custom:promodescription"],
      team_code_expiration_date: attributes["custom:promoexpirationdate"]
    };

    store.dispatch(setCurrentUser(dataObj));
    joincode === null && history.replace("/");
  } catch (error) {
    history.replace("/signin");
  }
  store.dispatch(setIsLoading(false));
};
